<div *ngIf="listItem.status != 's00_closed'">
  <ng-container *ngIf="listItem.active; else withoutLink">
    <a
      [href]="generateHref(listItem?.eventCode,listItem?.performanceCode, region, lang, {definitionCode: definitionCode})">
      <div class="performance-listing" [ngClass]="performanceItemClasses()">
        <div class="date-box" *ngIf="parentEventFlexibleTime">
          <span class="day">
            <mat-icon>calendar_month</mat-icon>
          </span>
        </div>
        <div class="date-box" *ngIf="!parentEventFlexibleTime">
          <span class="day">{{date|localizedDate:dayFormat}}</span>
          <span class="month">{{date|localizedDate:monthFormat}}</span>
          <!-- DİKKAT: bu satırdaki .month sınıfı AY ADI değil SAAT taşıyor (timeFormat);
               sınıf yalnızca tarih kutusu tipografisi için yeniden kullanılmış, adı
               değiştirilmiyor. Yukarıdaki :13 ay adını her genişlikte koşulsuz basar.
               Mobilde/masaüstünde değişen tek şey saatin YERİ: mobilde tarih kutusunun
               içinde (burada), masaüstünde aşağıdaki .time-icon + .time ikilisinde.
               Görünürlük SCSS'te; bkz. list-item.component.scss başındaki ngx-layout/SSR notu. -->
          <span class="month listitem-mobile-only">{{date|localizedDate:timeFormat}}</span>
        </div>
        <div class="divider">&nbsp;</div>
        <div fxLayout="column">
          <div fxLayout="row" fxLayoutGap="5px" class="info-group">
            <mat-icon class="time-icon listitem-desktop-only">schedule</mat-icon>
            <span class="time listitem-desktop-only">{{date|localizedDate:timeFormat}}</span>
            <mat-basic-chip class="status" [ngClass]="statusClasses()">{{ ('performance.status.' + listItem?.status) |
              translate }}</mat-basic-chip>
            <mat-basic-chip class="status flex-time-event" *ngIf="parentEventFlexibleTime">{{
              'shared.labels.flexibleTime' | translate }}</mat-basic-chip>
          </div>
          <div fxLayout="row" class="performance-listing-venue">
            {{listItem?.venueName}}
          </div>
          <div fxLayout="row" class="performance-listing-event">
            {{ listItem?.shortName }}
          </div>
          <div fxLayout="row" class="performance-listing-price" *ngIf="listItem?.minPrice && listItem.minPrice !== '0'">
            <mat-icon>local_offer</mat-icon>
            <span><small class="price-prefix">{{ 'home.labels.pricePrefix' | translate }}</small>{{ listItem?.minPrice | customCurrency }}<small class="price-suffix">{{ 'home.labels.priceSuffix' | translate }}</small></span>
          </div>
        </div>
        <div class="campaign-title-holder" *ngIf="listItem?.campaignTitle">
          <mat-basic-chip class="campaign-title">{{listItem?.campaignTitle}}</mat-basic-chip>
        </div>
        <div class="chevron-right" *ngIf="listItem?.active">
          <span class="find-ticket">
            <mat-icon>chevron_right</mat-icon>
          </span>
        </div>
      </div>

    </a>
  </ng-container>

  <ng-template #withoutLink>
    <div class="performance-listing" [ngClass]="performanceItemClasses()">
      <div class="date-box">
        <span class="day">{{date|localizedDate:dayFormat}}</span>
        <span class="month">{{date|localizedDate:monthFormat}}</span>
      </div>
      <div class="divider">&nbsp;</div>
      <div fxLayout="column">
        <div fxLayout="row" fxLayoutGap="5px" class="info-group">
          <mat-icon class="time-icon">schedule</mat-icon>
          <span class="time">{{date|localizedDate:timeFormat}}</span>
          <mat-basic-chip class="status" [ngClass]="statusClasses()">{{ ('performance.status.' + listItem?.status) |
            translate }}</mat-basic-chip>
          <mat-basic-chip class="status flex-time-event" *ngIf="parentEventFlexibleTime">{{
            'shared.labels.flexibleTimeEventTitle' | translate }}</mat-basic-chip>
        </div>
        <div fxLayout="row" class="performance-listing-venue">
          {{listItem?.venueName}}
        </div>
        <div fxLayout="row" class="performance-listing-event">
          {{ listItem?.eventName }}
        </div>
      </div>
      <div class="chevron-right" *ngIf="listItem?.active">
        <mat-icon>chevron_right</mat-icon>
      </div>
    </div>
  </ng-template>
</div>